export default {
      id: "ic_comment_author-usage",
      viewBox: "0 0 14 15",
      url: "/" + "images/icons.3.109.2.svg#ic_comment_author-usage",
      toString: function () {
        return this.url;
      }
    }